module.exports = __webpack_public_path__ + "static/img/thesydney.c77bb87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesydney.png
// module id = /rZf
// module chunks = 14